import React, {useEffect, useState} from "react";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import DispatchService from "../../../../services/dispatch/dispatch-service.js";
import projectUtils from "../../../../utils/project-utils.js";

const getErrorMessage = (error, fallback) => {
    const message = error.response?.data?.errorMessages ?? error.response?.data?.message;
    if (Array.isArray(message)) return message.join("<br />");
    return message || fallback;
};

const GenerateBoModal = ({payload, boName, onClose, onSuccess}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const open = Boolean(payload);
    const garrison = payload?.garrison;

    useEffect(() => {
        if (!open) return;
        setIsSubmitting(false);
    }, [open]);

    const handleGenerate = async () => {
        if (!garrison?.dispatchId) {
            projectUtils.swalErrorMessage("Erro", "Não foi possível identificar o despacho.", "Ok");
            return;
        }

        setIsSubmitting(true);

        try {
            const generatedBo = await DispatchService.generateNumberBo(garrison.dispatchId);
            onClose();

            if (!generatedBo) {
                projectUtils.swalMessage("error", "Erro", `A natureza não permite número de ${boName}`, "Ok");
                return;
            }

            projectUtils.swalSuccessMessage(
                "success",
                "Sucesso",
                `${boName} ${generatedBo.id} gerado com sucesso! <br> Localizador: ${generatedBo.code}`,
                "Ok",
                false, 'Não', undefined, false, true
            );
            onSuccess();
        } catch (error) {
            console.error("Erro ao gerar número de BO pelo dashboard:", error);
            projectUtils.swalErrorMessage("", getErrorMessage(error, `Não foi possível gerar um número de ${boName}`), "Ok");
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} setOpen={onClose} title={`Gerar número de ${boName}`} className="w-full max-w-2xl" isCloseClick={false}>
            <Modal.Body className="flex flex-col gap-4">
                <div>
                    <p className="text-[14px] font-bold">Dados do despacho</p>
                    <div className="mt-2 flex flex-col text-sm ">
                        <span><strong>Natureza: </strong>{garrison?.dispatchNature}</span>
                        {garrison?.dispatchAddress ? <span><strong>Local: </strong>{garrison.dispatchAddress}</span> : null}
                        <span><strong>Guarnição: </strong>{garrison?.garrisonName}</span>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" target="primary" onClick={handleGenerate} loading={isSubmitting} loadingText="Gerando...">
                    Gerar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GenerateBoModal;
